

import atlas from '@/components/atlas.vue';
import gallery from '@/components/homePage/gallery.vue'
import discussion from '@/components/homePage/discussion.vue'
import facus from '@/components/homePage/facus.vue'
import BlockUserDialog from '@/components/block/BlockUserDialog.vue'
import UnblockUserDialog from '@/components/block/UnblockUserDialog.vue'
import BlockedEmptyState from '@/components/block/BlockedEmptyState.vue'
import blockUserMixin from '@/mixins/blockUser'
import {
    BLOCK_ENTRY_POINT,
    isUserBlockedByMe,
    isUserProfileContentHiddenByOther,
} from '@/utils/blockUser'
export default {
    components: { atlas, gallery, discussion, facus, BlockUserDialog, UnblockUserDialog, BlockedEmptyState },
    mixins: [blockUserMixin],
    name: 'index',
    head() {
        // 优化seo：动态设置title，keywords 和 description
        return {
            title: this.source.user_info.nickname,
            description: this.source.user_info.signature || "This guy didn't write anything"
        };
    },
    data() {
        return {
            source: {
                user_info: { user_label: [], hobby: [] },
                worksList: {},
            },//数据
            nav_type: 'gallery',
            dialogVisible: false,
            rand_code: '',//随机码
            hottestWork: [],//默认展示作品
            userTip: false,
            userInfoForm: { usermedal_list: [] },
            upload_img: [],
            img_list: [],
            dialogUserInfo: false,
            notwrite: 'This person did not write anything',//个人信息空描述
        };
    },
    async asyncData({ $global, params, app }) {
        let res = await $global.otherUserWorks({ "user_id": params.id, "order_type": 1, "page": 1, 'page_num': 20 })
        if (res.code == 200) {
            return { source: res.data, rand_code: res.data.rand_code, hottestWork: res.data.worksList.data.slice(0, 3) }
        }
        else { error({ statusCode: 500 }) }

    },
    computed: {
        currentUid() {
            return this.$store.state.userInfo && this.$store.state.userInfo.userInfo && this.$store.state.userInfo.userInfo.uid
        },
        isOwnProfile() {
            return Boolean(this.currentUid && Number(this.currentUid) === Number(this.source.user_info.uid))
        },
        /** 已拉黑只认服务端/本地写入的 is_blocked_by_me === 1 */
        isBlockedByMe() {
            return isUserBlockedByMe(this.source.user_info)
        },
        /** 被拉黑者：is_blocked_by_me === 0 且 is_profile_content_hidden === 1 */
        isProfileContentHiddenByOther() {
            return isUserProfileContentHiddenByOther(this.source.user_info)
        },
        showBlockedEmptyState() {
            return this.isBlockedByMe || this.isProfileContentHiddenByOther
        },
        blockEmptyVariant() {
            return this.isProfileContentHiddenByOther ? 'hidden' : 'blocker'
        },
    },
    created() {
    },
    mounted() {
        // this.getUserInfo()
        console.log(this.$route, 'this.$route.params.id')
    },
    beforeRouteEnter(to, from, next) {

        if (to.params.id != null && typeof Number(to.params.id) == 'number' && to.params.id != undefined) {
            if (from.matched.length != 0) {
                if (to.params.id == from.matched[0].instances.default.$store?.state?.userInfo?.userInfo?.uid) {
                    next({
                        path: '/user/gallery'
                    })
                } else {
                    next()
                }
            } else {
                next()
            }
        } else {
            next({
                path: '/'
            })
        }
        // next()
    },
    methods: {
        // 个人中心
        async getUserInfo() {

            let res = await this.$global.otherUserWorks({ "user_id": this.$route.params.id, "order_type": 2, "page": 1, 'page_num': 20 })
            console.log(res, 'res')
            res.code = '200' ? (this.source = res.data, this.rand_code = res.data.rand_code, this.hottestWork = res.data.worksList.data.slice(0, 3)) : []

        },
        // 图片失败
        imgOnError(e) {
            e.srcElement.src = require('@/assets/image/global/bg-default.webp')
        },
        /** 拉黑成功后立即切已拉黑态，并隐藏对方社区输出 */
        applyBlockedState() {
            this.$set(this.source.user_info, 'is_blocked_by_me', 1)
            this.$set(this.source.user_info, 'is_profile_content_hidden', 1)
            this.source.user_info.is_follow_author = 0
        },
        /** 移出成功后恢复可见态，并重新拉取对方公开内容 */
        applyUnblockedState() {
            this.$set(this.source.user_info, 'is_blocked_by_me', 0)
            this.$set(this.source.user_info, 'is_profile_content_hidden', 0)
            this.getUserInfo()
        },
        /** 个人主页拉黑入口，来源只传 profile */
        async onClickBlockUser() {
            try {
                await this.openBlockDialog({
                    target_user_id: this.source.user_info.uid,
                    entry_point: BLOCK_ENTRY_POINT.PROFILE,
                    nickname: this.source.user_info.nickname,
                    avatar: this.source.user_info.user_thumb_compress || this.source.user_info.user_face_url,
                })
                this.applyBlockedState()
            } catch (e) {
                // 取消、未登录或参数非法时不改页面状态
            }
        },
        /** 主页空态「移出黑名单」：二次确认后解除关系 */
        async onClickUnblockUser() {
            try {
                await this.openUnblockDialog({
                    target_user_id: this.source.user_info.uid,
                    nickname: this.source.user_info.nickname,
                    avatar: this.source.user_info.user_thumb_compress || this.source.user_info.user_face_url,
                })
                this.applyUnblockedState()
            } catch (e) {
                // 取消或未登录时保持已拉黑态
            }
        },
        goBlacklistSettings() {
            this.$router.push({ path: '/setup/blacklist' })
        },
        async focusOn(id) {
            //关注用户
            if (this.isBlockedByMe || this.isProfileContentHiddenByOther) return
            let res = await this.$global.doFollow({ "fid": id })
            res.code == '200' ? (this.source.user_info.is_follow_author = 1, this.$message(res.msg)) : ''
        },
        async unsubscribe(id) {
            //取消关注用户
            let res = await this.$global.unFollow({ "fid": id })
            res.code == '200' ? (this.source.user_info.is_follow_author = 0, this.$message(res.msg)) : ''
        },
        /** 拉黑空态时 facus 未挂载，禁止打开粉丝/关注弹层 */
        fansHanle(val) {
            if (this.showBlockedEmptyState || !this.$refs.child) return
            this.$refs.child.dialog(val)
        }
    },
    watch: {
        nav_type(val) {
            if (this.isBlockedByMe || this.isProfileContentHiddenByOther) return
            // 切回作品 Tab 时重新拉取；先置空结构以触发子组件空态
            if (val == 'gallery') {
                this.source.worksList = { data: [], total: 0 }
                this.getUserInfo()
            }
        }
    }
}
